
const m = window.require("discourse/lib/keyboard-shortcuts");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
